import React from "react";
import URLs from "constants/urls";
import ProductBusiness from "../Reports/productBusiness";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
export default function ProductWiseBusinesByDsa() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const url1 = `${URLs.productWiseBusinessByDsaId}`;
  const url2 = `${URLs.productWiseBusinessByProductId}`;
  return (
    <DashboardLayout>
      <ProductBusiness
        productWiseBusinesByDateRange={url1}
        productWiseBusinessByProductId={url2}
        isItByDsa={true}
      />
    </DashboardLayout>
  );
}
